import React from 'react'
import { Container, Grid} from '@mui/material';
import MainTitle from './mainTitle';
import { ReactSlider } from '../../utils/utils';
import MUICard from '../muiCommonComponent/muiCard';

function Event() {
    const events = [
        {
            date: '23 Oct 2026',
             title: '5th International Conference',
             description: 'Brochure',
             link: '/assets/img/5th_international_conference_a4.pdf',
             img: '/assets/img/5th_international_conference_a4.jpg',
        },
        {
            date: '30th Sept 2026',
             title: 'ICSTST  Conference 2026',
             description: 'Brochure',
             link: 'https://www.mvn.edu.in/icstst-2026.html',
             img: '/assets/img/new_confreence01.jpg',
        },
        {
            date: '30th June 2026',
             title: 'Special Convocation For International Students',
             description: 'Brochure',
             link: '',
             img: '/assets/img/New_event0898.jpg',
        },
 

         {
            date: '22nd May 2026',
             title: 'Campus Training By Cisco',
             description: 'Brochure',
             link: '',
             img: '/assets/img/New_event0897.jpg',
        },
        
        
         {
            date: '22nd May 2026',
             title: '3rd Placement Conclave 2026',
             description: 'Brochure',
             link: '',
             img: '/assets/img/New_event0877.jpg',
        },



         {
            date: 'Job Oriented',
             title: 'Job Oriented',
             description: 'Brochure',
             link: '',
             img: '/assets/img/New_event055.jpg',
        },



     /*   {   
            title:'MVN UNIVERSITY (ENVISAGE 2K25) Participation Registration Form',
            
            date: '15 November, 2024',
            src: `${process.env.PUBLIC_URL}/assets/img/news_event01.jpg`,
            description: 'Brochure.',
            link: `https://docs.google.com/forms/d/e/1FAIpQLSfFNq3wQxfwoQIU-6H5K3IoQurjcnm36vlVrQM6t5EHhCN0LQ/viewform`,
            img: `${process.env.PUBLIC_URL}/assets/img/news_event01.jpg`,

        }, 
        {
            title:'Star-Night (ENVISAGE 2K25) Registration Form',
            src: `${process.env.PUBLIC_URL}/assets/img/news_event01.jpg`, 
            link: `https://docs.google.com/forms/d/e/1FAIpQLSeUHhOqAnNVtzfaUp3B25wwpZQfp3J0wRwUFyi4F9Sqfz2RNA/viewform`, 
             
            description: 'Brochure.', 
            img: `${process.env.PUBLIC_URL}/assets/img/news_event01.jpg`,



        }, */
         {
            date: 'We Are Hiring',
             title: 'Officer/ Coordinator',
             description: 'Brochure',
             link: 'career',
             img: '/assets/img/marchcareer.jpg',
        },
        {
            date: 'From 5th December 2025',
             title: 'Reimagine Your Work, Redefine Your Impact, Reinvent With AI',
             description: 'Brochure',
             link: 'https://forms.gle/zfVkbBj96XS6xhA27',
             img: '/assets/img/feb_event_2026.jpg',
        },

        {
            date: 'From 5th December 2025',
             title: 'Emerging Role of AI in Transforming Teaching Pedagogy and Learning Practices',
             description: 'Brochure',
             link: 'https://forms.gle/zfVkbBj96XS6xhA27',
             img: '/assets/img/november_event_2025.png',
        }, 

        // {
        //     date: '14-15 November, 2025',
        //     title: '4th International Conference on "Campus to Corporate 5.0 : A Multidisciplinary Conference - Bridging Technology, Humanity & Healthcare", organized by MVN University  in hybrid mode.',
        //     description: 'Brochure.',
        //     link: '/conference',
        //     img: '/assets/img/new-event042.jpg',
        // }, 
         {
            date: '15 November, 2024',
            title: 'Deekshaarambh Welcome Batch of 2025',
            description: 'Brochure.',
            link: '/',
            img: '/assets/img/new-event041.jpg',
        }, 
        {
            date: '15 November, 2024',
            title: '3rd International Conference on Recent advancements and innovations in health care',
            description: 'Brochure.',
            link: '/assets/pdf/3rd International Conference Brochure A4.pdf',
            img: '/assets/img/new-event033.jpg',
        }, 
        // {
        //     date: '15 November, 2024',
        //     title: 'Diwali Milan Samaroh',
        //     description: 'Diwali Milan Samaroh.',
        //     link: '',
        //     img: '/assets/img/new-event02.jpg',
        // },
        // {
        //     date: '15 November, 2024',
        //     title: '3rd International Conference on Recent advancements and innovations in health care',
        //     description: '3rd International Conference on Recent advancements and innovations in health care.',
        //     link: 'https://forms.gle/icXC3Y5EBWrZfUWE7 ',
        //     img: '/assets/img/new-event01.jpg',
        // },
        // {
        //     date: '22 March, 2023',
        //     title: 'PROTECTION WOMEN AND CHILDREN',
        //     description: 'Establish and enforce comprehensive legal frameworks that address issues such as domestic violence, child abuse, human trafficking, child labor, and child marriage.',
        //     link: '/',
        //     img: 'https://admission.mvn.edu.in/wp-content/uploads/2022/02/Workshop-School-of-Law.jpg',
        // },
        // {
        //     date: '22 March, 2023',
        //     title: 'Decenterlizing Trust With Blockchain Technology',
        //     description: 'Establish and enforce comprehensive legal frameworks that address issues such as domestic violence, child abuse, human trafficking, child labor, and child marriage.',
        //     link: '/',
        //     img: 'https://admission.mvn.edu.in/wp-content/uploads/2022/02/Faculty-Development-Program-Technology-Series.jpg',
        // },
        // {
        //     date: '22 March, 2023',
        //     title: 'PROTECTION WOMEN AND CHILDREN',
        //     description: 'Establish and enforce comprehensive legal frameworks that address issues such as domestic violence, child abuse, human trafficking, child labor, and child marriage.',
        //     link: '/',
        //     img: 'https://admission.mvn.edu.in/wp-content/uploads/2022/02/Faculty-Development-Program-Agriculture.jpg',
        // },
        // {
        //     date: '22 March, 2023',
        //     title: 'PROTECTION WOMEN AND CHILDREN',
        //     description: 'Establish and enforce comprehensive legal frameworks that address issues such as domestic violence, child abuse, human trafficking, child labor, and child marriage.',
        //     link: '/',
        //     img: 'https://admission.mvn.edu.in/wp-content/uploads/2022/02/Faculty-Development-Program-Agriculture.jpg',
        // },
        // {
        //     date: '22 March, 2023',
        //     title: 'PROTECTION WOMEN AND CHILDREN',
        //     description: 'Establish and enforce comprehensive legal frameworks that address issues such as domestic violence, child abuse, human trafficking, child labor, and child marriage.',
        //     link: '/',
        //     img: 'https://admission.mvn.edu.in/wp-content/uploads/2022/02/Faculty-Development-Program-Agriculture.jpg',
        // },
        // {
        //     category: 'Finance',
        //     title: 'Corporate Finance',
        //     description: "To become a CPA, you must earn a bachelor's degree in business administration, finance, or accounting and complete 150 hours of coursework.",
        //     link: '/single-courses',
        //     img: '/assets/img/bg/couress-img-6.jpg',
        // },
    ];
    const eventContent=()=>(
        <Grid container spacing={3}  className="slideontet_new">
         {/* <Grid item xs={12} sm={12} md={12} lg={12} >
                        <MainTitle title="Upcoming Events"/>
                    </Grid> */}
                    <Grid item xs={12} sm={12} md={12} lg={12} >         
        <ReactSlider cardList={events}   />
        </Grid>
        </Grid>
    )
return (
    <Container id="upcoming_events" >
        <MUICard title={'Upcoming Events'} content={eventContent()}/>   
    </Container>
)
}

export default Event